<div
  class="image-gallery"
  [class.drag-over]="dragOver && canEdit && !reachedLimit"
  (dragenter)="onDragEnter($event)"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">
  @if (sortedImages.length > 0) {
    <div class="thumbs">
      @for (img of sortedImages; track trackById(i, img); let i = $index) {
        <div class="thumb">
          <img
            [src]="img.url"
            [width]="100"
            [height]="100"
            loading="lazy"
            referrerpolicy="no-referrer"
            alt="product image"
            (click)="openGalleria(i)"
            (error)="onImageError($event, img)" />
          @if (canEdit) {
            <button
              pButton
              iconOnly
              type="button"
              class="p-button-rounded p-button-danger p-button-sm thumb-delete"
              aria-label="削除"
              (click)="onDelete(img)">
              <i
                class="pi pi-trash"
                aria-hidden="true"></i>
            </button>
          }
        </div>
      }
    </div>
  }

  @if (sortedImages.length === 0) {
    <div class="empty">画像はまだありません。</div>
  }

  @if (canEdit) {
    <div class="upload-area">
      <p-fileupload
        #fu
        mode="basic"
        [auto]="true"
        [multiple]="false"
        [accept]="acceptMime"
        [maxFileSize]="maxBytes"
        chooseLabel="画像を追加"
        [disabled]="uploading || reachedLimit"
        (onSelect)="onUploadSelected($event, fu)"></p-fileupload>
      @if (reachedLimit) {
        <span class="limit-warning">画像は最大{{ maxImages }}枚までです。</span>
      }
      @if (uploading) {
        <span class="uploading">アップロード中...</span>
      }
      <small class="hint">
        画像をこのエリアにドラッグ&ドロップでも追加できます。 対応形式: JPG / PNG / WebP　上限 20MB / 枚。 iPhone から
        HEIC をアップロードできない場合は「設定 → カメラ → フォーマット → 互換性優先」をお試しください。
      </small>
    </div>
  }

  <p-galleria
    [(visible)]="galleriaVisible"
    [value]="sortedImages"
    [activeIndex]="activeIndex"
    [fullScreen]="true"
    [showThumbnails]="true"
    [showItemNavigators]="true"
    [circular]="true">
    <ng-template
      #item
      let-item>
      <img
        [src]="item.url"
        referrerpolicy="no-referrer"
        class="galleria-item-image"
        alt="商品画像" />
    </ng-template>
    <ng-template
      #thumbnail
      let-item>
      <img
        [src]="item.url"
        width="80"
        referrerpolicy="no-referrer"
        alt="商品画像のサムネイル" />
    </ng-template>
  </p-galleria>

  <p-confirmdialog></p-confirmdialog>
</div>
